import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { parseCriteriaText } from '@backrs_ui/common-ui/src/utils/criteriaText.util';

import { Box, SxProps, Theme, Typography } from '@mui/material';

const CRITERIA_TEXT_STRINGS = appStrings.modules.assessMyTrack.criteriaText;

type CriteriaTextProps = Readonly<{
  text: string;
  textSx?: SxProps<Theme>;
}>;

export const CriteriaText = ({ text, textSx }: CriteriaTextProps) => {
  const parsed = parseCriteriaText(text);

  return (
    <Box sx={containerSx}>
      <Typography variant="text-sm-regular" sx={textSx}>
        {parsed.main}
      </Typography>
      {(parsed.counts || parsed.doesNotCount) && (
        <Box>
          {parsed.counts && (
            <Typography variant="text-xs-regular" sx={textSx}>
              <Typography component="span" variant="text-xs-semibold">
                {CRITERIA_TEXT_STRINGS.counts}{' '}
              </Typography>
              {parsed.counts}
            </Typography>
          )}
          {parsed.doesNotCount && (
            <Typography variant="text-xs-regular" sx={textSx}>
              <Typography component="span" variant="text-xs-semibold">
                {CRITERIA_TEXT_STRINGS.doesNotCount}{' '}
              </Typography>
              {parsed.doesNotCount}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-lg'],
});
